import { convertChainToLoyaltyProgram } from 'components/OfferPage/utils'
import Group from 'components/utils/Group'
import React from 'react'

interface Props {
  bedbankLoyaltyDisplay: 'searchTile' | 'offerPage';
  chainInfo?: string
}

function _PriceRowLoyaltyPointsContent({
  bedbankLoyaltyDisplay,
  chainInfo
}: Props) {
  return <Group direction="horizontal" wrap="wrap" gap={4}>
    {bedbankLoyaltyDisplay === 'searchTile' && <>Earn {convertChainToLoyaltyProgram(chainInfo)} points on select stays</>}
    {bedbankLoyaltyDisplay === 'offerPage' && <>Earn {convertChainToLoyaltyProgram(chainInfo)} points</>}
  </Group>
}

export default _PriceRowLoyaltyPointsContent
